import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./../../../styleSheet/main/admin/hr/documents/directives/directives.css";
import deleteButtonIcon from "../../../media/delete-button.svg";
import httpClient, { API_URL } from "../../../services/httpClient";
import { downloadFile } from "../../../services/download";
import { getIconForSingleFile } from "../../../services/iconUtils";
import { useAuth } from "../../../AuthContext";
import BenefitDocumentsList from "./../../../components/BenefitDocumentsList";

const PPWR = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();

  const isAdmin = (userData) => {
    return (
      userData?.userRole === "admin" || userData?.userRole === "hr-manager"
    );
  };

  const apiEndpoint = useCallback(async () => {
    return await httpClient.get(
      "hrdocuments/category?category=ppwr&subcategory=ppwr",
      {
        withAuth: true,
      },
    );
  }, []);

  const apiEndpointWithDelete = useMemo(() => {
    const endpoint = apiEndpoint;
    endpoint.delete = async (id) => {
      return await httpClient.delete(`hrdocuments/${id}`, {
        withAuth: true,
      });
    };
    return endpoint;
  }, [apiEndpoint]);

  return (
    <BenefitDocumentsList
      apiEndpoint={apiEndpointWithDelete}
      sectionTitle={t("header.ppwr")}
      createPath="/administrator/pliki/dokumenty/ppwr/nowe-ppwr"
      editPathPrefix="/administrator/pliki/dokumenty/ppwr/edytuj/"
      isAdmin={isAdmin}
      getIconForSingleFile={getIconForSingleFile}
      downloadFile={downloadFile}
      API_URL={API_URL}
      userData={userData}
      deleteButtonIcon={deleteButtonIcon}
    />
  );
};

export default PPWR;
